import { render, staticRenderFns } from "./AddASite.vue?vue&type=template&id=33b36e47&scoped=true"
import script from "./AddASite.vue?vue&type=script&lang=js"
export * from "./AddASite.vue?vue&type=script&lang=js"
import style0 from "./AddASite.vue?vue&type=style&index=0&id=33b36e47&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b36e47",
  null
  
)

export default component.exports